import React, { useEffect, useRef, useState } from 'react';
import Select from 'react-select';
import '../../../assets/css/sign-off-request-modal.css';
import deleteBtn from '../../../assets/img/delete.svg';
import attechFile from '../../../assets/img/ios-attach.svg';
import filePic from '../../../assets/img/file-picture.svg';
import { fetchProjectMilestones, fetchProjectTeamMembers } from '../../../utils/fetchData';
import APIServices from '../../../services/APIServices';
import { daysOptions, formatOptions, MAX_FILE_SIZE, selectLoader, validateTextInput } from '../../../utils/Helpers';
import appToast, { TOAST_TYPE } from '../../../utils/AppToast';
import { useStore } from '../../../hooks/useStore';

import delete3 from 'assets/img/delete4.svg';
import documentFile from '../../../assets/img/document-file.svg';
import attechFile2 from '../../../assets/img/ios-attach2.svg';
import user from '../../../assets/img/nick-user2.png';

const SignOffForm = ({
  updatedMilestoneId = '',
  projectId = '',
  milestoneId = '',
  requestId = '',
  closeModal,
  isInternalProject = false
}) => {
  const [store, setStore] = useStore();
  const customDaysRef = useRef(null);
  // const [projectId, setProjectId] = useState("");
  const [mileStonesList, setMileStonesList] = useState([]);
  const [mileStones, setMileStones] = useState([]);
  const [isEditing, setEditing] = useState(false);
  const [currentMileStone, setCurrentMileStone] = useState(null);
  const [requestDetails, setRequestDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [pageLoading, setPageLoading] = useState(false);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [statusOptions, setStatusOptions] = useState([]);
  const [files, setFiles] = useState([]);
  const [filestoDelete, setFilesToDelete] = useState([]);
  const [clientOptions, setClientOptions] = useState([]);
  const [teamOptions, setTeamOptions] = useState([]);
  const [showCustomDaysInput, setShowCustomDaysInput] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const [formData, setFormData] = useState({
    milestoneId: updatedMilestoneId || '',
    signoffStatus: '',
    attachments: [],
    description: '',
    signoffDeadline: '',
    projectId: '',
    // title: "",
    requestType: 'sign_off',
    requestRecipients: [],
    signoffType: isInternalProject ? 'internal' : 'external'
  });
  const [errors, setErrors] = useState({});
  const recipientOptions = formData.signoffType === 'internal' ? teamOptions : clientOptions;

  useEffect(() => {
    if (store.projectId) {
      // setProjectId(store.projectId);
      setFormData((prevData) => ({
        ...prevData,
        projectId: store.projectId
      }));
    }
  }, [store.projectId]);

  useEffect(() => {
    if (isInternalProject) {
      setFormData((prevData) => ({
        ...prevData,
        signoffType: 'internal',
        requestRecipients: prevData.signoffType === 'internal' ? prevData.requestRecipients : []
      }));
    }
  }, [isInternalProject]);

  useEffect(() => {
    if (Number(formData.signoffDeadline) > 7) {
      setShowCustomDaysInput(true);
    }
  }, [formData.signoffDeadline]);

  const fetchMilestones = async () => {
    setPageLoading(true);
    try {
      let milestones = await fetchProjectMilestones(projectId, 'update');
      // if (milestones.length > 0) {
      setMileStones(milestones);
      if (milestoneId) {
        let currentMilestone = milestones.find((x) => x._id == milestoneId);
        setCurrentMileStone(currentMilestone);
        if (requestId) {
          fetchRequestDetails(requestId);
        }
      } else {
        setPageLoading(false);
      }
      // }
      fetchStatusOptions();
    } catch (error) {
      console.error('Error fetching milestones:', error);
      setPageLoading(false);
    } finally {
      setPageLoading(false);
    }
  };

  const fetchRequestDetails = async (requestId) => {
    try {
      let response = await APIServices.get(`/project-requests/detail/${requestId}`);
      if (response.data) {
        setRequestDetails(response.data);
      }
      fetchStatusOptions();
    } catch (error) {
      console.error('Error fetching milestones:', error);
    } finally {
      setPageLoading(false);
    }
  };

  const fetchStatusOptions = async () => {
    setLoading(true);
    try {
      const response = await APIServices.get(`/enum?item_type=milestonstatus&filter=inprogress,complete`);
      if (response && response.length > 0) {
        const formattedOptions = formatOptions(response);
        setStatusOptions(formattedOptions);
        // Set first status as default
        setFormData((prev) => ({
          ...prev,
          signoffStatus: prev.signoffStatus || formattedOptions[0]?.value
        }));
      }
    } catch (error) {
      console.error('Error fetching status options:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMilestones();
    if (milestoneId && requestId) {
      setEditing(true);
    }
  }, []);

  useEffect(() => {
    if (!projectId) {
      return;
    }

    fetchProjectTeamMembers(projectId, setClientOptions, 'user2');
    fetchProjectTeamMembers(projectId, setTeamOptions, 'user1');
  }, [projectId]);

  useEffect(() => {
    console.log(clientOptions, 'clientOptions');
  }, [clientOptions]);

  useEffect(() => {
    if (requestDetails) {
      setFormData((prevData) => ({
        ...prevData,
        description: requestDetails?.description,
        attachments: requestDetails?.attachments,
        signoffDeadline: requestDetails?.signoffDeadline > 0 ? requestDetails?.signoffDeadline : '',
        requestRecipients: requestDetails?.requestRecipients?.map((recipient) => recipient._id) || [],
        signoffStatus: requestDetails?.signoffStatus?._id,
        signoffType: isInternalProject ? 'internal' : requestDetails?.signoffType
      }));
      setFiles(requestDetails?.attachments);
    }
  }, [requestDetails, isInternalProject]);

  useEffect(() => {
    if (currentMileStone) {
      console.log(currentMileStone);
      let latestUpdates = currentMileStone?.latestUpdate[0];
      setFormData((prevData) => ({
        ...prevData,
        milestoneId: currentMileStone._id
        // signoffStatus: currentMileStone?.status?._id
      }));
      console.log(currentMileStone?.signOffTime);

      // if (latestUpdates?.updateStatus?.value)
      //   setCurrentStatus(latestUpdates?.updateStatus?.value);
    }
  }, [currentMileStone]);

  useEffect(() => {
    if (mileStones?.length > 0) {
      const formattedOptions = formatOptions(mileStones);
      setMileStonesList(formattedOptions);
    }
  }, [mileStones]);

  // Handle file selection

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const droppedFiles = Array.from(e.dataTransfer.files);

    handleFiles(droppedFiles);
  };
  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    handleFiles(selectedFiles);
  };

  const handleFiles = (selectedFiles) => {
    const totalFiles = files.length + selectedFiles.length;

    if (totalFiles > 5) {
      appToast('You can upload a maximum of 5 files.', TOAST_TYPE.ERROR);
      return;
    }

    const totalSize =
      files.reduce((sum, file) => sum + file.size, 0) + selectedFiles.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > 40 * 1024 * 1024) {
      appToast('The total size of uploaded files should not exceed 40MB.', TOAST_TYPE.ERROR);
      return;
    }

    setFiles((prev) => [...prev, ...selectedFiles]);
  };

  const handleRemoveFile = (index) => {
    if (isEditing) {
      let fileToDelete = files.filter((_, i) => i == index);
      console.log(fileToDelete[0]._id);
      if (fileToDelete && fileToDelete.length > 0 && fileToDelete[0]._id) {
        setFilesToDelete((prevFiles) => [...prevFiles, fileToDelete[0]._id]);
      }
    }

    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };

  const handleFieldChange = (e, fieldName) => {
    const value = e.target ? e.target.value : e.value;
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value
    }));
    if (errors[fieldName]) {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
    }
  };
  // Handle input changes and remove error
  const handleInputChange = (e, fieldName) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: value
    }));

    if (errors[fieldName]) {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
    }
  };

  const handleDropdownChange = (selected, fieldName) => {
    setFormData((prevData) => ({
      ...prevData,
      [fieldName]: selected ? selected.value : null
    }));
    console.log(selected.value);

    if (errors[fieldName]) {
      setErrors((prevErrors) => ({ ...prevErrors, [fieldName]: '' }));
    }

    if (fieldName == 'milestoneId') {
      const currentMilestone = mileStones.find((x) => x._id === selected?.value);
      setCurrentMileStone(currentMilestone);
      console.log(currentMilestone);
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.milestoneId) {
      newErrors.milestoneId = 'Please select a milestone.';
    }

    // if (!validateTextInput(formData.description).isValid) {
    //   if (!validateTextInput(formData.description).cleanedValue) {
    //     newErrors.description = "Request Description is required.";
    //   } else {
    //     newErrors.description = validateTextInput(formData.description).message;
    //   }
    // }

    if (!formData.signoffStatus) {
      newErrors.signoffStatus = 'Please select a status.';
    }

    // if (formData.signoffDeadline === "") {
    //   newErrors.signoffDeadline = "Please select the number of days.";
    // }

    // if (!formData.title.trim()) {
    //   newErrors.title = "Please enter Title.";
    // }
    // if (files.length === 0) {
    //   newErrors.files = "At least one file must be uploaded.";
    // }
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }
    setSubmitLoading(true);
    const formDataToSend = new FormData();

    // Dynamically append form fields
    Object.entries(formData).forEach(([key, value]) => {
      if (key === 'signoffDeadline') {
        if (value === '' || value === undefined) {
          // Skip attachments for now
          formDataToSend.append(key, 0);
        } else {
          formDataToSend.append(key, value);
        }
      }
      if (key !== 'attachments' && key !== 'signoffDeadline') {
        // Skip attachments for now
        if (Array.isArray(value)) {
          formDataToSend.append(key, value.join(','));
        } else {
          formDataToSend.append(key, value);
        }
      }
    });

    // Append attachments separately
    files.forEach((file) => {
      formDataToSend.append('attachments', file);
    });

    if (isEditing && filestoDelete.length > 0) {
      formDataToSend.append('deletedAttachments', filestoDelete.join(','));
    }

    try {
      const response = isEditing
        ? await APIServices.put(`/project-requests/${requestId}`, formDataToSend, {
            'Content-Type': 'multipart/form-data'
          })
        : await APIServices.post('/project-requests', formDataToSend, {
            'Content-Type': 'multipart/form-data'
          });
      if (response.message) {
        appToast(response.message, TOAST_TYPE.SUCCESS);
        closeModal();
      } else if (response.data.message) {
        appToast(response.data.message, TOAST_TYPE.ERROR);
        closeModal();
      }
    } catch (error) {
      console.error('Error submitting sign-off request:', error);
      appToast('An error occurred. Please try again.', TOAST_TYPE.ERROR);
    } finally {
      setSubmitLoading(false);
    }
  };

  const dayOptions = [1, 2, 3, 4, 5, 6, 7];

  const handleRecipientToggle = (userId) => {
    setFormData((prev) => {
      const alreadySelected = prev.requestRecipients.includes(userId);

      return {
        ...prev,
        requestRecipients: alreadySelected
          ? prev.requestRecipients.filter((id) => id !== userId)
          : [...prev.requestRecipients, userId]
      };
    });
  };

  const handleSelectAllRecipients = () => {
    const allIds = recipientOptions.map((client) => client.value);

    const isAllSelected = allIds.length > 0 && allIds.every((id) => formData.requestRecipients.includes(id));

    setFormData((prev) => ({
      ...prev,
      requestRecipients: isAllSelected ? [] : allIds
    }));
  };

  if (pageLoading) {
    return <div className="nodata-loader"> {selectLoader(60)}</div>;
  }

  return (
    <form onSubmit={handleSubmit}>
      <div className="updatedSignOff-form">
        <div className="updatedSignOff-leftSec">
          {/* tabe btn */}
          <div className="signOffTabe-list">
            {!isInternalProject && (
              <button
                type="button"
                className={`signOffTabe-link ${formData.signoffType === 'external' ? 'active' : ''}`}
                onClick={() =>
                  setFormData((prev) => ({
                    ...prev,
                    signoffType: 'external',
                    requestRecipients: []
                  }))
                }>
                Client sign-off
              </button>
            )}

            <button
              type="button"
              className={`signOffTabe-link ${formData.signoffType === 'internal' ? 'active' : ''}`}
              onClick={() =>
                setFormData((prev) => ({
                  ...prev,
                  signoffType: 'internal',
                  requestRecipients: []
                }))
              }>
              Internal sign-off
            </button>
          </div>
          {formData.signoffType === 'internal' && (
            <div className="internal-signoff-info">
              Internal sign-offs are not visible to the client. Use this to get team approval before sending anything
              externally.
            </div>
          )}
          <div className="milestone-needs mt-3">
            <div className="milestone-left">
              <div className="row">
                <div className="col-lg-12">
                  <div className="form-group">
                    <label className="form-lable">Which milestone needs signing off?</label>
                    <Select
                      className={`form-control select2 ${errors.milestoneId ? 'form-invalid' : ''} ${
                        isEditing || updatedMilestoneId ? 'input-desable' : ''
                      }`}
                      options={mileStonesList}
                      placeholder="Select Milestone"
                      value={mileStonesList.find((option) => option.value === formData.milestoneId)}
                      onChange={(e) => handleDropdownChange(e, 'milestoneId')}
                      isClearable
                      isLoading={loading}
                      isDisabled={isEditing || updatedMilestoneId}
                    />
                    {/* {errors.milestoneId && <small className="text-danger">{errors.milestoneId}</small>} */}
                  </div>
                </div>
              </div>
            </div>
            <div className="milestone-status">
              <div className="radio-group">
                {statusOptions.map((option) => (
                  <label className="radio-option">
                    <input
                      type="radio"
                      name="status"
                      checked={formData.signoffStatus === option.value}
                      onChange={() => handleFieldChange({ target: { value: option.value } }, 'signoffStatus')}
                    />
                    <span className="custom-radio"></span>
                    <span>{option.label}</span>
                  </label>
                ))}
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="form-lable">What would you like us to review or approve?</label>
                <textarea
                  className={`form-control ${errors.description ? 'form-invalid' : ''}`}
                  name="description"
                  value={formData.description}
                  onChange={(e) => handleFieldChange(e, 'description')}
                  placeholder="Describe what needs to be reviewed, approved, or signed off. Include any notes or changes."
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="form-lable">Respond in (Optional)</label>
                <div className="day-selector">
                  {dayOptions.map((day) => (
                    <button
                      type="button"
                      key={day}
                      className={`day-btn ${
                        Number(formData.signoffDeadline) === day && !showCustomDaysInput ? 'active' : ''
                      }`}
                      onClick={() => {
                        setShowCustomDaysInput(false);

                        setFormData((prev) => ({
                          ...prev,
                          signoffDeadline: day
                        }));
                      }}>
                      {day}d
                    </button>
                  ))}

                  {/* Other Button */}
                  {!showCustomDaysInput ? (
                    <button
                      type="button"
                      className={`day-btn other ${showCustomDaysInput ? 'active' : ''}`}
                      onClick={() => {
                        setShowCustomDaysInput(true);

                        setFormData((prev) => ({
                          ...prev,
                          signoffDeadline: ''
                        }));
                      }}>
                      Other
                    </button>
                  ) : (
                    <div className="other-days-input">
                      <input
                        type="text"
                        placeholder="Days"
                        value={formData.signoffDeadline}
                        onChange={(e) => {
                          const value = e.target.value.replace(/[^0-9]/g, '');

                          if (value === '') {
                            setFormData((prev) => ({
                              ...prev,
                              signoffDeadline: ''
                            }));
                            return;
                          }

                          const numericValue = Number(value);

                          if (numericValue <= 100) {
                            setFormData((prev) => ({
                              ...prev,
                              signoffDeadline: numericValue
                            }));
                          } else {
                            appToast('Number of Days must not exceed 100.', TOAST_TYPE.WARNING);
                          }
                        }}
                        onKeyDown={(e) => {
                          if (e.key === 'Escape') {
                            setShowCustomDaysInput(false);
                          }
                        }}
                        className="other-days-field"
                        autoFocus
                      />

                      <span className="days-text">d</span>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12">
              <div className="form-group">
                <label className="form-lable">Attachments (Optional)</label>
                <div className="cardbg-form-group">
                  <div
                    className={`attech-file-cover ${isDragging ? 'drag-active' : ''}`}
                    onDrop={(e) => {
                      handleDrop(e);
                      setIsDragging(false);
                    }}
                    onDragOver={(e) => e.preventDefault()}
                    onDragEnter={() => setIsDragging(true)}
                    onDragLeave={() => setIsDragging(false)}>
                    <img src={attechFile2} alt="Attach" className="attechFile" />
                    <a className="attech-btn">
                      <p>Drop files here or click to upload</p>
                      <label className="add-btn-text cursor_pointer">
                        <input
                          type="file"
                          multiple
                          accept="image/*,.pdf,.doc,.docx,.xls,.xlsx"
                          onChange={handleFileChange}
                          style={{ display: 'none' }}
                        />
                        Screenshots, mockups, or reference documents
                      </label>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="file_grid_row row">
            {files.map((file, index) => (
              <div className="col-lg-4 col-md-6 col-sm-6" key={index}>
                <div className="file_card">
                  <div className="file_preview">
                    <a href={file.url || URL.createObjectURL(file)} target="_blank" rel="noreferrer">
                      <img src={documentFile} alt="File" className="documentFile" />
                    </a>
                  </div>

                  <div className="file_info">
                    <div className="file_info_content">
                      <div className="file_name">{file.name || file.originalname}</div>

                      <div className="file_time">
                        {(file.size / 1024).toFixed(2) !== 'NaN' ? `${(file.size / 1024).toFixed(2)} KB` : ''}
                      </div>
                    </div>

                    <img src={delete3} className="cursor_pointer" onClick={() => handleRemoveFile(index)} />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <button className="btn-black" type="submit" disabled={submitLoading}>
            {submitLoading ? selectLoader(35) : isEditing ? 'Update' : 'Submit'}
          </button>
        </div>
        <div className="updatedSignOff-righttSec">
          <div className="client-name">Request Sign-off</div>

          <div className="list">
            {/* Select All */}
            <div className="item">
              <div className="left">
                <div className="name">All</div>
              </div>

              <label className="custom-checkbox">
                <input
                  type="checkbox"
                  checked={
                    recipientOptions.length > 0 &&
                    recipientOptions.every((client) => formData.requestRecipients.includes(client.value))
                  }
                  onChange={handleSelectAllRecipients}
                />
                <span></span>
              </label>
            </div>

            {/* Dynamic Client List */}
            {recipientOptions.map((client) => (
              <div className="item" key={client.value}>
                <div className="left">
                  <img src={client.profilePic || user} alt="User" className="avatar" />

                  <div className="name">{client.label}</div>
                </div>

                <label className="custom-checkbox">
                  <input
                    type="checkbox"
                    checked={formData.requestRecipients.includes(client.value)}
                    onChange={() => handleRecipientToggle(client.value)}
                  />
                  <span></span>
                </label>
              </div>
            ))}
          </div>
        </div>
      </div>
    </form>
  );
};

export default SignOffForm;
